import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ISection, ISectionState } from "./sectionModel";
import {
  ActiveInactiveSection,
  createSection,
  deleteSection,
  getAllActiveSection,
  getAllSection,
  getSectionByID,
  sectionImageUpload,
  updateSection,
} from "./services/section.services";

const initialState: ISectionState = {
  loading: false,
  formloading: false,
  error: "",
  SectionID: null,
  SectionList: [],
  SectionDetail: {
    TagLine: "",
    Title: "",
    SubTitle: "",
    SectorID: null,
    Position: "",
    URL: "",
    IsActive: 1,
  },
};

const sectionSlice = createSlice({
  name: "section",
  initialState,
  reducers: {
    clearSectionDetails: (state) => {
      state.SectionDetail = initialState.SectionDetail;
    },
    setSectionID: (state, action) => {
      state.SectionID = action.payload;
    },
    clearSectionID: (state) => {
      state.SectionID = initialState.SectionID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllSection.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllSection.fulfilled,
      (state, action: PayloadAction<ISection[]>) => {
        state.loading = false;
        state.SectionList = action.payload || [];
      }
    );
    builder.addCase(getAllSection.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.SectionList = [];
    });
    builder.addCase(createSection.pending, (state) => {
      state.formloading = true;
      state.error = "";
    });
    builder.addCase(createSection.fulfilled, (state) => {
      state.formloading = false;
    });
    builder.addCase(createSection.rejected, (state, action) => {
      state.formloading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateSection.pending, (state) => {
      state.formloading = true;
      state.error = "";
    });
    builder.addCase(updateSection.fulfilled, (state) => {
      state.formloading = false;
    });
    builder.addCase(updateSection.rejected, (state, action) => {
      state.formloading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteSection.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteSection.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteSection.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getSectionByID.pending, (state) => {
      state.formloading = true;
      state.error = "";
    });
    builder.addCase(getSectionByID.fulfilled, (state, action: any) => {
      state.formloading = false;
      state.SectionDetail = action.payload;
    });
    builder.addCase(getSectionByID.rejected, (state, action) => {
      state.formloading = false;
      state.SectionDetail = initialState.SectionDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveSection.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveSection.fulfilled,
      (state, action: PayloadAction<ISection[]>) => {
        state.loading = false;
        state.SectionList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveSection.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.SectionList = [];
    });
    builder.addCase(ActiveInactiveSection.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveSection.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveSection.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(sectionImageUpload.pending, (state) => {
      state.formloading = true;
      state.error = "";
    });
    builder.addCase(sectionImageUpload.fulfilled, (state) => {
      state.formloading = false;
    });
    builder.addCase(sectionImageUpload.rejected, (state, action) => {
      state.formloading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearSectionDetails, clearSectionID, setSectionID } =
  sectionSlice.actions;
export default sectionSlice.reducer;
